<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.iconColor'
      showEdit
      @edit='editBasics'
    >
      <wc-two-column-table
        :items='data'
        @rowClick='editBasics'
      ></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='toolbarData.title'
      :icon='toolbarData.icon'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
      width='350'
    >
      <v-form v-model='isFormValid' ref='form'>
        <basics-form v-model='profileCopy'></basics-form>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import BasicsForm from '../../components/forms/BasicsForm'

export default {
  name: 'profile-basics',
  props: {
    profile: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    showDialog: false,
    profileCopy: {},
    isFormValid: false,
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.basics
    },
    data () {
      return [
        { text: 'First name', value: this.profile.first_name },
        { text: 'Last name', value: this.profile.last_name },
        { text: 'Username', value: this.profile.username }
      ]
    }
  },
  methods: {
    editBasics () {
      this.profileCopy = _.cloneDeep(this.profile)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.profileCopy)
      this.showDialog = false
    }
  },
  components: {
    'basics-form': BasicsForm
  }
}
</script>
